module.exports = __webpack_public_path__ + "static/media/logo.86f54ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 73
// module chunks = 0